"use client";
import { Card, CardActionArea, Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";

function SizeBox({
  borderDashed,
  size,
  selected,
  onChange,
}: {
  borderDashed: boolean;
  size: string;
  selected: boolean;
  onChange: (name: string) => void;
}) {
  return (
    <>
      <Card
        elevation={0}
        sx={{
          boxSizing: "border-box",
          border: selected ? 1 : 1,
          borderStyle: borderDashed ? "dashed" : "solid",
          borderColor: selected ? "transparent" : "grey.300",
          borderRadius: 50,
          minWidth: 50,
          height: 32,
          backgroundColor: selected ? "primary.main" : "unset",
          transition: "0.1s all ease",
          cursor: "pointer",
        }}
        onClick={() => {
          onChange(size);
        }}
      >
        <CardActionArea sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", px: 1 }}>
          <Typography variant={"body1"} color={selected ? "white.main" : borderDashed ? "grey.300" : "inherit"}>
            {size}
          </Typography>
        </CardActionArea>
      </Card>
    </>
  );
}

type Props = {
  sizes: (string | null | undefined)[];
  value?: string | null;
  dashed?: string[];
  onChange: (value: string | null) => void;
};
export default function ProductVariantsSectionSizesSelect({ sizes, value, onChange, dashed }: Props) {
  return (
    <Stack spacing={0.5}>
      <Stack direction={"row"} alignItems={"center"} spacing={1}>
        <Typography variant={"subtitle2"} color={"grey.700"} component={"div"}>
          تنوع :
        </Typography>
        <Typography variant={"subtitle2"} color={"grey.800"} component={"div"}>
          {sizes.find((a) => a === value) || ""}
        </Typography>
      </Stack>
      <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1 }}>
        {sizes &&
          sizes.length > 0 &&
          sizes.map((a, index) => {
            if (!a) {
              return <></>;
            }
            const selected = value === a;
            return (
              <SizeBox
                key={index}
                selected={selected}
                borderDashed={Boolean(dashed && dashed.length > 0 && dashed.includes(a))}
                size={a}
                onChange={(title) => {
                  onChange(title);
                }}
              ></SizeBox>
            );
          })}
      </Box>
    </Stack>
  );
}
